import { Root as root } from './root'
import { Main as main } from './main'
import { Icon as icon } from './icon'
import { Text as text } from './text'
import { Coupons as coupons } from './coupons'
import { Button as button } from './button'

export const CouponsSection = {
  root,
  main,
  icon,
  text,
  coupons,
  button
}
